export const platformPostMessage = ({ action = '', data = {} }) => {
  const message = {
    appName: 'app-idverify',
    type: `THIRD-PARTY-APP.${action}`,
    body: data,
  };

  postMessage(message, window.location.origin);
};

export const saveOnStorage = ({
  key,
  value,
}: {
  key: string;
  value: string | Record<string, unknown>;
}): void =>
  window.localStorage.setItem(key, typeof value === 'string' ? value : JSON.stringify(value));

export const setSessionStorage = (key: string, value: string) => {
  sessionStorage.setItem(key, value);
};

export function getRawParam(paramName: string, queryString: string) {
  const params = queryString.split('&');

  for (const param of params) {
    const [key, value] = param.split('=');

    if (key === paramName) {
      return value || null;
    }
  }

  return null;
}

export const getQueryParam = (paramName: string) => {
  const urlParams = new URL(window.location.href);

  let queryString = urlParams.toString();
  queryString = queryString?.split('?')[1];

  if (queryString) {
    return getRawParam(paramName, queryString);
  }

  return null;
};

export const isMobile = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|windows phone|mobile|tablet/i.test(
    userAgent
  );
};
